import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onGetOne } from 'redux/actions/documentsTypes.actions';

import LayoutContainer from 'containers/LayoutContainer';
import DocumentsTypesShow from 'views/DocumentsTypesView/components/DocumentsTypesShow';
import Loading from 'components/commons/Loading';

import 'views/DocumentsTypesView/components/DocumentsTypesShow/i18n';

const DocumentsTypesShowContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id = '' } = useParams<{ id?: string }>();
  const { loading, selectedItem: item } = useTypedSelector((state) => state.documentsTypes);

  useEffect(() => {
    if (id) dispatch(onGetOne(id));
    return () => {
      dispatch(onGetOne(''));
    };
  }, [dispatch, id]);

  return (
    <LayoutContainer auth title={i18next.t<string>('DOCUMENTS_TYPES_SHOW:TITLE')}>
      <DocumentsTypesShow item={item} />
      {loading && (
        <Loading isModalMode message={i18next.t<string>('DOCUMENTS_TYPES_SHOW:LOADING')} />
      )}
    </LayoutContainer>
  );
};

export default DocumentsTypesShowContainer;
